module.exports = __webpack_public_path__ + "assets/confirm-email.0a60a297.svg";